import React, { Component } from 'react'
import Isvg from 'react-inlinesvg'
import SectionHeader from '../components/Header/Section'
import Footer from '../components/Footer'
import Card from '../components/Card/Blog'
import '../components/Pagination/Pagination.scss'
import iconArrow from '../sass/icons/next.svg'

class BlogPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            articles: [],
            currentPage: 1,
            totalPages: 1
        }
    }

    componentDidMount() {
        this.fetchArticles()
    }

    fetchArticles(page = 1) {
        const perPage = 8
        fetch(`https://api.talkative.media/v1/blog?page=${page}`)
            .then(response => response.json())
            .then(response => {
                console.log(response)
                this.setState({
                    articles: response.results,
                    totalPages: Math.ceil(response.count / perPage),
                    currentPage: page
                })
            })
    }

    renderArticles() {
        return this.state.articles.map(article => <Card {...article} />)
    }

    handleNextPage() {
        this.fetchArticles(this.state.currentPage + 1)
    }

    handlePrevPage() {
        this.fetchArticles(this.state.currentPage - 1)
    }

    render() {
        return (
            <div>
                <SectionHeader>
                    <h2 className="blog-title">Artigos</h2>
                </SectionHeader>
                <section className="article-list">
                    <div className="container">
                        <div className="grid">
                            <div className="col-12">
                                { this.renderArticles() }
                            </div>
                        </div>
                        <div className="grid">
                            <div className="col-12">
                                <div className="pagination">
                                    <button className={`prev ${this.state.currentPage <= 1 ? 'hidden' : ''}`} onClick={() => this.handlePrevPage()}>
                                        <Isvg src={iconArrow} />
                                        Posts mais novos
                                    </button>
                                    <p>Página <span className="currentPage">{this.state.currentPage}</span> de {this.state.totalPages}</p>
                                    <button className={`next ${this.state.currentPage >= this.state.totalPages ? 'hidden' : ''}`} onClick={() => this.handleNextPage()}>
                                        Posts mais antigos
                                        <Isvg src={iconArrow} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        );
    }
}

export default BlogPage


// WEBPACK FOOTER //
// ./src/pages/blog.js